module.exports = __webpack_public_path__ + "static/media/status_ok.f4fdc0e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/status_ok.jpg
// module id = 1883
// module chunks = 0